import { gql } from '@apollo/client';
import { API_FIELDS_APPLICATION as APPLICATION, API_FIELDS_APPLICATION_PET as APPLICATION_PET } from '@enroller/admissions-components';
import { createNestedPayload, createStringPayload } from '../utils/formatSchema';

import type { FieldResponse } from '../graphqlResponse';

const HOUSING_FIELDS = [
  APPLICATION.youngChildrenFeelings,
  APPLICATION.attendReligiousServices,
  APPLICATION.willAttendWithHostFamily,
  APPLICATION.religiousPreference,
  APPLICATION.religiousPreferenceOther,
  APPLICATION.understandNoSmoking,
  APPLICATION.adjustToSmokers,
];

const PETS_FIELDS = [
  APPLICATION.doNotOwnPets,
  APPLICATION.adjustToIndoorPet,
  APPLICATION.noIndoorPetExplanation,
  APPLICATION.afraidOfPets,
  APPLICATION.afraidOfPetExplanation,
];

const PETS_LIST_FIELDS = [APPLICATION_PET.id, APPLICATION_PET.name, APPLICATION_PET.size, APPLICATION_PET.type];

const PETS_FIELDS_GQL = `
  ${createStringPayload(PETS_FIELDS)}
  ${createNestedPayload(APPLICATION.petsListGET, PETS_LIST_FIELDS)}
`;

const PLACEMENT_FIELDS = [APPLICATION.acceptDoublePlacement, APPLICATION.acceptSingleHost, APPLICATION.acceptSameSexCouple, APPLICATION.acceptSmallSchool];
const FOOD_FIELDS = [APPLICATION.dietRestricted, APPLICATION.prepareOwnMeals, APPLICATION.adjustToVegetarian];
const MEALS_FIELDS = [APPLICATION.specialMeals, APPLICATION.makeSpecialMeals];

const ALLERGIES_FIELDS = [
  APPLICATION.allergicToAnimals,
  APPLICATION.allergyDogReaction,
  APPLICATION.allergyCatReaction,
  APPLICATION.allergyHorseReaction,
  APPLICATION.allergyOtherAnimal,
  APPLICATION.allergyOtherAnimalExplanation,
  APPLICATION.nonAllergicDogBreeds,
  APPLICATION.dogIndoorsNotInRoom,
  APPLICATION.dogOnlyAtNight,
  APPLICATION.dogOccasionallyIndoors,
  APPLICATION.dogOutsideOnly,
  APPLICATION.catIndoorsNotInRoom,
  APPLICATION.catOnlyAtNight,
  APPLICATION.catOccasionallyIndoors,
  APPLICATION.catOutsideOnly,
  APPLICATION.allergicToDust,
  APPLICATION.cannotLiveWithCarpet,
  APPLICATION.allergicToFood,
  APPLICATION.listFoodAllergies,
  APPLICATION.allergicToPollen,
  APPLICATION.wearsGlassesOrContacts,
];

export const HOUSING_FOOD_ALLERGIES_PETS_QUERY = gql`
  query StudentApp($appId: String!) {
    Records {
      Students_Applications(where: { id: { equals: $appId } }) {
        _data {
          id { value }
          ${PETS_FIELDS_GQL}
          ${createStringPayload(HOUSING_FIELDS)}
          ${createStringPayload(PLACEMENT_FIELDS)}
          ${createStringPayload(FOOD_FIELDS)}
          ${createStringPayload(MEALS_FIELDS)}
          ${createStringPayload(ALLERGIES_FIELDS)}
        }
      }
    }
  }
`;

type PetsFieldsResponse = FieldResponse<typeof PETS_FIELDS> & {
  [APPLICATION.petsListGET]: {
    _data: Array<FieldResponse<typeof PETS_LIST_FIELDS>>; // see createNestedPayload implementation
  };
};

export type HousingFoodAllergiesPetsResponse = FieldResponse<typeof HOUSING_FIELDS> &
  PetsFieldsResponse &
  FieldResponse<typeof PLACEMENT_FIELDS> &
  FieldResponse<typeof MEALS_FIELDS> &
  FieldResponse<typeof FOOD_FIELDS> &
  FieldResponse<typeof ALLERGIES_FIELDS>;
